/* All Is Well — hero slideshow + interactive diagram.
   Ported from the approved mockup. Idempotent init so it also works
   when sections are re-rendered in the Shopify theme editor. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHero(hero) {
    if (!hero || hero.dataset.aiwInit) return;
    hero.dataset.aiwInit = '1';
    var slides = Array.prototype.slice.call(hero.querySelectorAll('.hero-slide'));
    if (!slides.length) return;
    var dotWrap = hero.querySelector('[data-hero-dots]');
    var i = 0, timer = null;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      if (dotWrap) Array.prototype.forEach.call(dotWrap.children, function (d, k) {
        d.classList.toggle('is-active', k === i);
      });
    }
    function next() { show(i + 1); }
    function play() { if (!reduce && slides.length > 1) { stop(); timer = setInterval(next, 5000); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    if (dotWrap) {
      dotWrap.innerHTML = '';
      slides.forEach(function (_, k) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Show slide ' + (k + 1));
        b.addEventListener('click', function () { show(k); play(); });
        dotWrap.appendChild(b);
      });
    }
    show(0);
    play();
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', play);
  }

  function initDiagram(diagram) {
    if (!diagram || diagram.dataset.aiwInit) return;
    diagram.dataset.aiwInit = '1';
    var keyed = Array.prototype.slice.call(diagram.querySelectorAll('[data-key]'));
    function activate(key) {
      keyed.forEach(function (el) { el.classList.toggle('is-active', el.dataset.key === key); });
    }
    keyed.forEach(function (el) {
      el.addEventListener('mouseenter', function () { activate(el.dataset.key); });
      el.addEventListener('focus', function () { activate(el.dataset.key); });
      el.addEventListener('click', function () { activate(el.dataset.key); });
    });
  }

  function initTestimonials(slider) {
    if (!slider || slider.dataset.aiwInit) return;
    slider.dataset.aiwInit = '1';
    var track = slider.querySelector('[data-tslide-track]');
    var slides = Array.prototype.slice.call(slider.querySelectorAll('.tslide'));
    var dotWrap = slider.querySelector('[data-tslide-dots]');
    var prev = slider.querySelector('[data-tslide-prev]');
    var nextBtn = slider.querySelector('[data-tslide-next]');
    if (!slides.length) return;
    var i = 0;
    function show(n) {
      i = (n + slides.length) % slides.length;
      if (track) track.style.transform = 'translateX(' + (-i * 100) + '%)';
      slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      if (dotWrap) Array.prototype.forEach.call(dotWrap.children, function (d, k) {
        d.classList.toggle('is-active', k === i);
        d.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
    }
    if (slides.length < 2) {
      [prev, nextBtn, dotWrap].forEach(function (el) { if (el) el.style.display = 'none'; });
      show(0);
      return;
    }
    if (dotWrap) {
      dotWrap.innerHTML = '';
      slides.forEach(function (_, k) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Show testimonial ' + (k + 1));
        b.addEventListener('click', function () { show(k); });
        dotWrap.appendChild(b);
      });
    }
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(i + 1); });
    var x0 = null;
    slider.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1));
      x0 = null;
    });
    show(0);
  }

  function initMobileNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu || toggle.dataset.aiwInit) return;
    toggle.dataset.aiwInit = '1';
    function setOpen(open) {
      menu.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    toggle.addEventListener('click', function () { setOpen(!menu.classList.contains('is-open')); });
    Array.prototype.forEach.call(menu.querySelectorAll('[data-nav-close]'), function (el) {
      el.addEventListener('click', function () { setOpen(false); });
    });
  }

  function initAll(root) {
    var scope = root || document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-hero]'), initHero);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-diagram]'), initDiagram);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-tslider]'), initTestimonials);
    initMobileNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Re-init when the theme editor loads/reloads a section */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
